import React from 'react';

/**
 * Tiny markdown-to-React formatter for inline reasoning text.
 * Supports a strict subset (no deps, no XSS surface):
 *   **bold**, __bold__
 *   *italic*, _italic_
 *   `code`
 * Unsupported markdown is rendered as plain text.
 *
 * @param {string} text
 * @returns {Array<React.ReactNode>}
 */
export function formatInlineMarkdown(text) {
    if (!text) return [];
    const tokens = [];
    const regex = /(\*\*[^*\n]+\*\*|__[^_\n]+__|\*[^*\n]+\*|_[^_\n]+_|`[^`\n]+`)/g;
    let lastIndex = 0;
    let match;
    let key = 0;
    while ((match = regex.exec(text)) !== null) {
        if (match.index > lastIndex) {
            tokens.push(text.slice(lastIndex, match.index));
        }
        const raw = match[0];
        if (raw.startsWith('**') || raw.startsWith('__')) {
            tokens.push(
                <strong key={`md-b-${key++}`} className="md-bold">
                    {raw.slice(2, -2)}
                </strong>
            );
        } else if (raw.startsWith('`')) {
            tokens.push(
                <code key={`md-c-${key++}`} className="md-code">
                    {raw.slice(1, -1)}
                </code>
            );
        } else {
            tokens.push(
                <em key={`md-i-${key++}`} className="md-italic">
                    {raw.slice(1, -1)}
                </em>
            );
        }
        lastIndex = match.index + raw.length;
    }
    if (lastIndex < text.length) {
        tokens.push(text.slice(lastIndex));
    }
    return tokens;
}

